import * as yup from 'yup';

export const schema = yup
  .object({
    des_arquivo: yup.string().required(),
    descricao: yup.string().required(),
    apelido: yup.string().required(),
    tipoInterface: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
  })
  .required();
